import { Box } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { PickersDay } from "@mui/x-date-pickers/PickersDay";
import { format } from "date-fns";
import { useState } from "react";
import { ReactComponent as CustomDropDownIcon } from "../../../assets/icons/green_arrow_down.svg";

interface DateAndTimeProps {
  selectedDate: Date | null;
  handleDateSelect: (date: Date) => void;
  bookableDates?: Record<string, { marked: boolean; dotColor: string }> | null;
}

const CustomDay = (props: any) => {
  const { day, selected, bookableDates = {}, ...other } = props;
  const formattedDate = format(day, "yyyy-MM-dd");
  const isBookable = bookableDates?.[formattedDate]?.marked || false;
  const dotColor = bookableDates?.[formattedDate]?.dotColor || "#328734";

  return (
    <PickersDay
      {...other}
      day={day}
      selected={selected}
      sx={{
        position: "relative",
        ...(isBookable && {
          "&::after": {
            content: '""',
            position: "absolute",
            bottom: 2,
            left: "50%",
            width: 6,
            height: 6,
            borderRadius: "50%",
            backgroundColor: dotColor,
            transform: "translateX(-50%)",
          },
        }),
      }}
    />
  );
};

const AvailabilityDatePicker: React.FC<DateAndTimeProps> = ({
  selectedDate,
  handleDateSelect,
  bookableDates = null,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            backgroundColor: "white",
            padding: "5px 10px",
            border: `1px solid black`,
            maxWidth: "460px",
            cursor: "pointer",
            margin: "0 auto",
            borderRadius: "8px",
            width: '100%'
          }}
          onClick={() => setOpen(true)}
        >
          <DatePicker
            value={selectedDate ? new Date(selectedDate) : null}
            onChange={(newValue: Date | null) => {
              setTimeout(() => setOpen(false), 0);
              if (newValue) {
                handleDateSelect(newValue);
              }
            }}
            format="eee, MMM dd"
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            minDate={new Date()}
            slots={{
              day: (dayProps) => (
                <CustomDay {...dayProps} bookableDates={bookableDates || {}} />
              ),
            }}
            sx={{width: "100%"}}
            slotProps={{
              textField: {
                variant: "standard",
                InputProps: {
                  readOnly: true,
                  endAdornment: (
                    <Box
                      sx={{
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setOpen(true);
                      }}
                    >
                      <CustomDropDownIcon />
                    </Box>
                  ),
                  disableUnderline: true,
                },
              },
            }}
          />
        </Box>
      </Box>
    </LocalizationProvider>
  );
};

export default AvailabilityDatePicker;
